<script>
    import { mapMutations, mapState } from 'vuex';
    import moment from 'moment/src/moment';
    import { getApplyBaseUrl } from '@/utils/helpers';
    import C1Button from '@/components/C1Components/C1Button';
    import ApplyMixin from '@/apps/apply/001/components/JobView/Apply/ApplyMixin';

    export default {
        components: {
            C1Button,
        },

        mixins: [ApplyMixin],

        props: {
            jobUuid: {
                type: String,
                default: '',
            },

            isOffsiteApply: {
                type: Boolean,
                default: false,
            },

            isCompleteApply: {
                type: Boolean,
                default: false,
            },
            isExpired: {
                type: Boolean,
                default: false,
            },

            jobAppliedAt: {
                type: Date,
                default: null,
            },

            userApplicationCount: {
                type: Number,
                default: null,
            },
        },
        
        computed: {
            ...mapState({
                $_job: state => state.job.job,
            }),

            canReapplyJob() {
                const allowJobReapply = window?.afConfig?.allow_job_reapply;
                if (!allowJobReapply) {
                    return true;
                }
                const canReapply = allowJobReapply.toLowerCase() === 'yes';
                if (!canReapply) {
                    return false;
                }
                const reapplyLimit = window?.afConfig?.job_reapply_limit;

                if (!reapplyLimit || reapplyLimit === '' || this.userApplicationCount < reapplyLimit) {
                    return true;
                }
                return false;
            },

            jobAppliedTime() {
                moment.locale('en', {
                    relativeTime: {
                        future: 'in %s',
                        past: '%s ago',
                        s:  'seconds',
                        ss: '%ss',
                        m:  'a minute',
                        mm: '%dm',
                        h:  '1h',
                        hh: '%dh',
                        d:  'a day',
                        dd: '%dd',
                        M:  '1mo',
                        MM: '%dmo',
                        y:  'a year',
                        yy: '%dY',
                    },
                });
                return (this.jobAppliedAt) ? moment.utc(this.jobAppliedAt).local().fromNow() : null;
            },
        },

        methods: {

            ...mapMutations('jobApplication', {
                $_APPLY: 'APPLY',
            }),

            ...mapMutations('job', {
                $_UPDATE_JOB: 'UPDATE_JOB',
            }),

            applyNow() {
                const isMatchedDomain = this.hasMatchedDomain();

                if (this.isOffsiteApply && !isMatchedDomain) {
                    this.applyOffsite();
                } else {
                    this.applyOnsite();
                }  
            },

            getSource() {
                const getParams = this.getUtmParameters();
                return getParams?.source ?? 'applyflow';
            },

            applyOffsite() {
                const source = this.getSource();
                const url = `/af-page/job-redirect?job_uuid=${this.jobUuid}&source=${source}`;
                window.open(url, '_blank');
                this.$_APPLY();
                this.$_UPDATE_JOB({ key: 'has_applied', value: true });
                this.$_UPDATE_JOB({ key: 'applied_at', value: moment().format('YYYY-MM-DD HH:mm:ss') });
            },

            applyOnsite() {
                const queryString = window.location.search;
                const applyURL = `${getApplyBaseUrl()}/${this.jobUuid}/${queryString}`;
                window.location.href = applyURL;
            },

            getMatchedDomain() {
                const matchedDomains = [];
                const domains = window?.afConfig?.use_iframe_for_external_apply_domain;
                const domainArr = domains ? domains.split(',').map(domain => domain.trim()) : [];

                const appURLDomain = this.$_job?.apply_url;
                if (appURLDomain) {
                    if (domainArr.length === 0) {
                        return ''; // or return null;
                    }

                    domainArr.forEach(domain => {
                        const strippedDomain = domain.replace('*.', '');
                        if (appURLDomain.includes(strippedDomain) || appURLDomain.includes(domain)) {
                            matchedDomains.push(domain);
                        }
                    });
                }
                return matchedDomains;
            },

            getQuerySymbol() {
                const applyUrl = new URL(this.$_job.apply_url);
                const querySymbol = applyUrl.href.includes('?') ? '&' : '?';
                return querySymbol;
            },

            hasMatchedDomain() {
                const hasMatch = this.getMatchedDomain().length > 0;
                return hasMatch;
            },

            isApplyInIframe() {
                const iframeApply = window?.afConfig?.use_iframe_for_external_apply?.toLowerCase() === 'yes';
                return iframeApply;
            },
        },
    };
</script>
